// BUG-2077: the one "needs a connection" treatment a control disabled offline carries (BL-2422's
// sidebar entries, Log Out, My Profile, the Print rows, Print labels, Sync now; ADR 044 — Must
// Consolidate): the no-wifi glyph plus the reason for a screen reader, and the button attributes.

import { WifiOff } from 'lucide-react';
import { clsx } from 'clsx';
import { NEEDS_CONNECTION } from './offline-copy';

/**
 * The attributes a natively disabled button carries while it needs a connection: the
 * `data-state` handle and the reason as its tooltip. Nothing while online.
 *
 * @param isOffline - the app's offline mode (`useOfflineMode().isOffline`).
 * @returns the attributes to spread onto the button.
 */
export function needsConnectionProps(isOffline: boolean): { 'data-state'?: 'needs-connection'; title?: string } {
  return isOffline ? { 'data-state': 'needs-connection', title: NEEDS_CONNECTION } : {};
}

/**
 * The no-wifi mark and, unless the control already shows the reason as visible text, the
 * reason as screen-reader text. With `aria-disabled` (or `disabled`) it is the second signal
 * ADR 051 — Contrast Floor rule 3 asks of a faded control.
 *
 * @param props.className - the glyph's size and spacing; defaults to 16px, not shrinking.
 * @param props.announce - add the reason as screen-reader text (default). Off when the control
 *   already shows it, so it isn't read twice.
 * @returns the mark.
 */
export default function NeedsConnectionMark({ className, announce = true }: { className?: string; announce?: boolean }) {
  return (
    <>
      <WifiOff className={clsx('h-4 w-4 flex-shrink-0', className)} aria-hidden />
      {announce && <span className="sr-only">{NEEDS_CONNECTION}</span>}
    </>
  );
}
